import React from "react";

export default function QuestionnaireAvgCompletionTime({ minutes, trend }) {

    /* =========================
       Safe values
       ========================= */

    const avgMinutes =
        typeof minutes === "number" && !isNaN(minutes) ? Math.round(minutes) : 0;

    const trendValues =
        Array.isArray(trend)
            ? trend.map(t => t.value).filter(v => typeof v === "number")
            : [];

    const last = trendValues.length > 0
        ? trendValues[trendValues.length - 1]
        : avgMinutes;

    const prev = trendValues.length > 1
        ? trendValues[trendValues.length - 2]
        : last;

    const delta =
        Math.round((last - prev) * 10) / 10; // minutes change

    const displayTrend =
        trendValues.length > 0
            ? trendValues.slice(-6)
            : [avgMinutes];

    /* =========================
       Helpers
       ========================= */

    function formatTimeFromMinutes(mins) {
        const totalSeconds = Math.round(mins * 60);
        const hrs = Math.floor(totalSeconds / 3600);
        const rem = totalSeconds % 3600;
        const m = Math.floor(rem / 60);
        const s = rem % 60;

        if (hrs > 0) {
            return `${hrs}h ${m}m ${s}s`;
        }
        return `${m}m ${s}s`;
    }
	
	
	function formatDuration(minutes) {
	  if (!minutes || minutes <= 0) {
	    return "0m";
	  }

	  const totalMinutes = Math.round(minutes);
	  const days = Math.floor(totalMinutes / (60 * 24));
	  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
	  const mins = totalMinutes % 60;

	  if (days > 0) {
	    return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
	  }

	  if (hours > 0) {
	    return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
	  }

	  return `${mins}m`;
	}


    /* =========================
       Styles (unchanged)
       ========================= */

    const styles = {

        card: {
            display: "flex",
            flexDirection: "column",
            padding: "14px 16px",
            height: "100%"
        },

        body: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "8px",
            marginTop: "-10px"
        },

        timeValue: {
            fontSize: "28px",
            fontWeight: 700,
            color: "#333",
            letterSpacing: "0.5px"
        },

        deltaPositive: {
            fontSize: "14px",
            fontWeight: 600,
            color: "#2e7d32"
        },

        deltaNegative: {
            fontSize: "14px",
            fontWeight: 600,
            color: "#c62828"
        },

        deltaLabel: {
            fontSize: "11px",
            color: "#777",
            marginBottom: "4px"
        },

        trend: {
            display: "flex",
            alignItems: "flex-end",
            height: "28px",
            gap: "3px",
            marginTop: "4px"
        },

        trendBar: {
            width: "6px",
            backgroundColor: "#bbb",
            borderRadius: "3px"
        },

        trendBarLast: {
            backgroundColor: "#4c9aff"
        }
    };

    /* =========================
       Render
       ========================= */

    return (
        <div style={styles.card}>

            <div style={styles.body}>

                {/* Digital Time */}
                <div style={styles.timeValue}>
                    {formatDuration(avgMinutes)}
                </div>

                {/* Delta */}
                <div style={delta <= 0 ? styles.deltaPositive : styles.deltaNegative}>
                    {delta > 0 ? "+" : ""}{delta}m
                </div>

                <div style={styles.deltaLabel}>
                    vs last period
                </div>

                {/* Trend */}
                <div style={styles.trend}>
                    {displayTrend.map(function (v, i) {
                        return (
                            <div
                                key={i}
                                title={formatTimeFromMinutes(v)}
                                style={{
                                    ...styles.trendBar,
                                    height: Math.max(6, Math.min(28, v)) + "px",
                                    ...(i === displayTrend.length - 1
                                        ? styles.trendBarLast
                                        : {})
                                }}
                            />
                        );
                    })}
                </div>

            </div>

        </div>
    );
}
